import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Institucion } from 'src/app/models/institucion.interface';
import { AdministradorService } from 'src/app/services/administrador.service';
@Component({
  selector: 'app-administrador-institucion-nuevo',
  templateUrl: './administrador-institucion-nuevo.component.html',
  styleUrls: ['./administrador-institucion-nuevo.component.scss'],
  providers: [MessageService]
})
export class AdministradorInstitucionNuevoComponent {
  institucionForm: FormGroup;
 
  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private administradorServices: AdministradorService,
  ) {    
    this.institucionForm = this.crearFormulario();
  }

  onSubmit() {
    if (this.institucionForm.valid) {
      const institucion: Institucion = this.institucionForm.value;
      this.administradorServices.setInstitucion(institucion).subscribe({
                next: (resp)=> { 
                  
                  this.messageService.add({
                  severity: 'success',
                  summary: 'Éxito',
                  detail: resp.mensaje
                }); 
                this.resetForm();
              }, 
              error: (err: HttpErrorResponse)=> {
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: err.error.message
                });
                this.markFormGroupTouched(this.institucionForm);
              }
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor complete todos los campos requeridos'
      });
      this.markFormGroupTouched(this.institucionForm);
    }
  }
  crearFormulario(): FormGroup {
    return this.fb.group({    
      nomInstitucion: ['', [Validators.required, Validators.minLength(3)]],
      cvInstitucion: ['', [Validators.required, Validators.minLength(2)]]
    });
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
    });
  }

  resetForm(): void {
    this.institucionForm.reset();
  }
  
  get f() {
    return this.institucionForm.controls;
  }
}
